//LAVORO
// const myConstClass = {
//     LOGIN: "http://localhost:3210/Progetti/fidal-bs/php-backend/login.php",
//     RICHIESTAABBONAMENTI: "http://localhost:3210/Progetti/fidal-bs/php-backend/richiestaAbbonamenti.php",
//     INSERTABBONAMENTO: "http://localhost:3210/Progetti/fidal-bs/php-backend/insertAbbonamento.php",
//     RICHIESTACAMPI: "http://localhost:3210/Progetti/fidal-bs/php-backend/richiestaCampi.php",
//     INSERTUTENTE : "http://localhost:3210/Progetti/fidal-bs/php-backend/insertUtente.php",
//     INSERTABBONAMENTOADMIN : "http://localhost:3210/Progetti/fidal-bs/php-backend/insertAbbonamentoAdmin.php",
//     BASE_URL : "http://localhost:3210/Progetti/fidal-bs/php-backend/",

// }
// export default myConstClass;

//CASA
// const myConstClass = {
//     LOGIN: "http://localhost:3210/php-backend/login.php",
//     RICHIESTAABBONAMENTI: "http://localhost:3210/php-backend/richiestaAbbonamenti.php",
//     INSERTABBONAMENTO: "http://localhost:3210/php-backend/insertAbbonamento.php",
//     RICHIESTACAMPI: "http://localhost:3210/php-backend/richiestaCampi.php",
//     INSERTUTENTE : "http://localhost:3210/php-backend/insertUtente.php",
//     INSERTABBONAMENTOADMIN : "http://localhost:3210/php-backend/insertAbbonamentoAdmin.php",
//     BASE_URL : "http://localhost:3210/php-backend/",

// }

// export default myConstClass;

const myConstClass = {
  LOGIN: "https://www.ratio-solution.cloud/php-backend/login.php",
  RICHIESTAABBONAMENTI:
    "https://www.ratio-solution.cloud/php-backend/richiestaAbbonamenti.php",
  INSERTABBONAMENTO:
    "https://www.ratio-solution.cloud/php-backend/insertAbbonamento.php",
  RICHIESTACAMPI:
    "https://www.ratio-solution.cloud/php-backend/richiestaCampi.php",
  INSERTUTENTE: "https://www.ratio-solution.cloud/php-backend/insertUtente.php",
  INSERTABBONAMENTOADMIN:
    "https://www.ratio-solution.cloud/php-backend/insertAbbonamentoAdmin.php",
  RECUPEROPASS:
    "https://www.ratio-solution.cloud/php-backend/insertAbbonamentoAdmin.php",
  BASE_URL: "https://www.ratio-solution.cloud/php-backend/",
};
/* const myConstClass = {
  LOGIN: "https://www.fidalbrescia.ratiosolutions.net/php-backend/login.php",
  RICHIESTAABBONAMENTI:
    "https://www.fidalbrescia.ratiosolutions.net/php-backend/richiestaAbbonamenti.php",
  INSERTABBONAMENTO:
    "https://www.fidalbrescia.ratiosolutions.net/php-backend/insertAbbonamento.php",
  RICHIESTACAMPI:
    "https://www.fidalbrescia.ratiosolutions.net/php-backend/richiestaCampi.php",
  INSERTUTENTE:
    "https://www.fidalbrescia.ratiosolutions.net/php-backend/insertUtente.php",
  INSERTABBONAMENTOADMIN:
    "https://www.fidalbrescia.ratiosolutions.net/php-backend/insertAbbonamentoAdmin.php",
  RECUPEROPASS:
    "https://www.fidalbrescia.ratiosolutions.net/php-backend/insertAbbonamentoAdmin.php",
  BASE_URL: "https://www.fidalbrescia.ratiosolutions.net/php-backend/",
}; */
export default myConstClass;
